import script from "./CompanionDebugView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionDebugView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionDebugView.vue?vue&type=style&index=0&id=74be594a&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74be594a"]])

export default __exports__